/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Inactive_BadgeInputs */

const en_us2_coaching_inactive_badge = /** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const pt_br2_coaching_inactive_badge = /** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumido`)
};

const pt_pt2_coaching_inactive_badge = /** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumido`)
};

/** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */
const es_419_coaching_inactive_badge = en_us2_coaching_inactive_badge;

/** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */
const fr_fr2_coaching_inactive_badge = en_us2_coaching_inactive_badge;

/** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */
const de_de2_coaching_inactive_badge = en_us2_coaching_inactive_badge;

/** @type {(inputs: Coaching_Inactive_BadgeInputs) => LocalizedString} */
const it_it2_coaching_inactive_badge = en_us2_coaching_inactive_badge;

/**
* | output |
* | --- |
* | "Missing" |
*
* @param {Coaching_Inactive_BadgeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_inactive_badge = /** @type {((inputs?: Coaching_Inactive_BadgeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Inactive_BadgeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_inactive_badge(inputs)
	if (locale === "es-419") return es_419_coaching_inactive_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_inactive_badge(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_inactive_badge(inputs)
	if (locale === "de-DE") return de_de2_coaching_inactive_badge(inputs)
	if (locale === "it-IT") return it_it2_coaching_inactive_badge(inputs)
	return en_us2_coaching_inactive_badge(inputs)
});
export { coaching_inactive_badge as "coaching.inactive_badge" }